import { processSteps } from '../../../mocks/homeData';

export default function ProcessTimeline() {
  return (
    <section className="bg-[#050505] py-28 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5"
        style={{ backgroundImage: "url('https://public.readdy.ai/ai/img_res/5580df9ae1ce44cbc23a165745ac3e11.jpg')", backgroundSize: 'cover' }} />
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-4 flex items-center justify-center gap-2">
            <span className="w-6 h-px bg-[#FF6B35]" />
            Our Process
            <span className="w-6 h-px bg-[#FF6B35]" />
          </span>
          <h2 className="font-display font-black text-5xl lg:text-6xl text-white leading-tight">
            Precision From
            <br />
            <span className="text-[#FF6B35]">Start to Finish</span>
          </h2>
          <p className="text-gray-500 text-base mt-4 max-w-lg mx-auto">
            Every vehicle goes through the same meticulous 4-step process — no shortcuts, no compromises.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          <div className="hidden lg:block absolute top-8 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-[#FF6B35]/40 to-transparent" />
          {processSteps.map((step, i) => (
            <div key={i} className="flex flex-col items-center text-center group">
              <div className="relative w-16 h-16 flex items-center justify-center mb-6">
                <div className="absolute inset-0 rounded-full border-2 border-[#FF6B35]/25 animate-ping"
                  style={{ animationDelay: `${i * 0.6}s`, animationDuration: '3s' }} />
                <div className="relative w-16 h-16 flex items-center justify-center bg-[#FF6B35] rounded-full z-10">
                  <span className="font-display font-black text-xl text-white">{step.number}</span>
                </div>
              </div>
              <div className="bg-[#111111] border border-white/8 rounded-2xl p-6 w-full group-hover:border-[#FF6B35]/30 transition-all">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mx-auto mb-4">
                  <i className={`${step.icon} text-[#FF6B35] text-xl`} />
                </div>
                <h3 className="text-white font-bold text-base mb-3">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <a href="#lead-form"
            className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold px-9 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill" /></span>
            Start Your Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
